import LanguageDeleteForm from "./language-delete-form";

export default LanguageDeleteForm;
